import {Customer} from "../../model/customer/customer";
import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../model/api/form-field-config";
import {Trader} from "../../model/customer/trader";
import {FieldRecord} from "../../model/api/field-record";
import {FieldRequest} from "../../model/api/field-request";
import {TranslateService} from "@ngx-translate/core";
import {CommonFieldService} from "../common/common-field.service";
import {FieldsService} from "../common/fields-service";
import {BrokerageTable} from "../../model/customer/brokerage-table";
import {MoneyOwner} from "../../model/customer/money-owner";
import {AccountDefinition} from "../../model/customer/account-definition";
import {Broker} from "../../model/customer/broker";
import {Trade} from "../../model/clearing/trade";
import {AccountTrader} from "../../model/customer/account-trader";
import {Owner} from "../../model/customer/owner";
import {ExchangeDetail} from "../../model/exchange/exchange-detail";
import {ExecTrader} from "../../model/customer/exec-trader";
import {AccountType} from "../../model/exchange/account-type";
import {
  OrderAmendmentTableComponent
} from "../../crystal-clear/data-amendment/order-amendment/table/order-amendment-table.component";
import {Order} from "../../model/clearing/order";
import {StringUtils} from "../../utils/stringUtils";
import OpenClose = AccountDefinition.OpenClose;

@Injectable({
  providedIn: 'root'
})
export class OrderAmendmentDataLoadingService {

  moneyOwners: FieldRecord<MoneyOwner>[] = [];

  customers: FieldRecord<Customer>[] = [];

  accounts: FieldRecord<AccountDefinition>[] = [];

  displayedAccounts: FieldRecord<AccountDefinition>[] = [];

  brokers: FieldRecord<Broker>[] = [];

  traders: FieldRecord<Trader>[] = [];

  accountTraders: FieldRecord<AccountTrader>[] = [];

  brokerageTables: FieldRecord<BrokerageTable>[] = [];

  owners: FieldRecord<Owner>[] = [];

  exchanges: FieldRecord<ExchangeDetail>[] = []

  execTraders: FieldRecord<ExecTrader>[] = [];

  displayedCustomers: FieldRecord<Customer>[] = [];

  originAccounts: FieldRecord<AccountDefinition>[] = [];

  accountTypes: FieldRecord<any>[] = [];

  displayedAccountTypes: FieldRecord<any>[] = [];

  displayedGUpAccountTypes: FieldRecord<any>[] = [];

  sides: FieldRecord<any>[] = []
  callPuts: FieldRecord<any>[] = []
  orderStates: FieldRecord<any>[] = []
  strategies: FieldRecord<any>[] = []

  constructor(private commonFieldService: CommonFieldService,
              private fieldsService: FieldsService,
              private translateService: TranslateService) {
  }

  loadData(component: OrderAmendmentTableComponent) {

    this.sides = Object.keys(Trade.Side).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.callPuts = Object.keys(Trade.CallPut).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.orderStates = Object.keys(Order.OrderState).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.strategies = Object.keys(Order.Strategy).map(key => new FieldRecord(key, StringUtils.humanize(key)));

    this.fieldsService.loadField(this.exchanges, () => this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.owners, () => this.commonFieldService.getOwners(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.customers, () => this.commonFieldService.getCustomers(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.originAccounts, () => this.commonFieldService.getAccounts(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.accountTypes, () => this.commonFieldService.getAccountTypes(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.traders, () => this.commonFieldService.getTraders(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.accountTraders, () => this.commonFieldService.getAccountTraders(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.brokerageTables, () => this.commonFieldService.getBrokerageTables(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.execTraders, () => this.commonFieldService.getExecTraders(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.moneyOwners, () => this.commonFieldService.getMoneyOwner(FieldRequest.DEFAULT()), component.tracker);

  }

  public filterCustomers(formRecord: Order) {
    debugger
    if (this.customers && formRecord) {
      this.displayedCustomers = this.customers.filter(field => {
        return !formRecord.owner || formRecord.owner === field.value.owner;
      });
    } else {
      this.displayedCustomers = [];
    }
    this.filterAccountFromCustomers(formRecord);
  }

  private filterAccountFromCustomers(formRecord: Order) {
    if (this.originAccounts && this.displayedCustomers && this.originAccounts.length > 0 && this.displayedCustomers.length > 0) {
      this.accounts.splice(0);
      this.originAccounts.forEach(field => {
        const hasExchange: boolean = formRecord.clearingHouse === field.value.clearingHouse
          && (!field.value.exchangeCode || field.value.exchangeCode === ExchangeDetail.ALL || formRecord.exchangeCode === field.value.exchangeCode);
        const customerField =
          this.displayedCustomers.find(customer => customer.value.id == field.value.customerId && hasExchange);
        if (customerField && customerField.value.enabled) {
          this.accounts.push({
            id: field.text,
            text: field.text,
            value: field.value
          });
        }
      });
    }
  }

  public filterAccounts(formRecord: Order, query?: string): any[] {
    debugger
    let tmpDisplayedAccounts = [];
    if (this.accounts && formRecord) {
      let customerId = undefined;
      if (!query) {
        if (formRecord.customerName && this.customers) {
          const customerField = this.customers.find(customer => customer.text === formRecord.customerName);
          if (customerField)
            customerId = customerField.id;
        }
      }
      tmpDisplayedAccounts = this.accounts.filter(field => {
        return formRecord.clearingHouse === field.value.clearingHouse
          && (!field.value.exchangeCode
            || field.value.exchangeCode === ExchangeDetail.ALL
            || formRecord.exchangeCode === field.value.exchangeCode)
          && (!customerId || '' + field.value.customerId === customerId)
          && (!query || field.value.code.toLowerCase().startsWith(query.toLowerCase()))
          ; /* this.formRecord.owner === field.value.owner
          && */
      });
    }
    return tmpDisplayedAccounts;
  }

  public filterAccountTypes(formRecord: Order) {
    let defaultGUType = FieldRecord.DEFAULT();
    defaultGUType.text = this.translateService.instant('page.account.form.defaultAccountTypeGup');
    defaultGUType.id = AccountType.GIVE_UP_CODE;
    if (this.accountTypes && formRecord) {
      this.displayedAccountTypes = this.accountTypes.filter(field =>
        field.id === AccountType.GIVE_UP_CODE || (
          (formRecord.clearingHouse === field.value.clearingHouse
            && (!field.value.exchangeCode || field.value.exchangeCode.length === 0
              || field.value.exchangeCode === ExchangeDetail.ALL
              || field.value.exchangeCode === ExchangeDetail.ALL_TEXT
              || formRecord.exchangeCode === field.value.exchangeCode))));
      this.displayedGUpAccountTypes = [...this.displayedAccountTypes];
      this.displayedAccountTypes.unshift(defaultGUType);
    } else {
      this.displayedAccountTypes = [defaultGUType];
      this.displayedGUpAccountTypes = [];
    }
  }

  public filterTraders(formRecord: Order): FieldRecord<Trader>[] {
    if (formRecord && formRecord.customerName) {
      const customerField: FieldRecord<Customer> = this.customers.find(cust => cust.text == formRecord.customerName);
      if (customerField && customerField.value && customerField.value.traders && customerField.value.traders.length > 0) {
        const traderCodes = customerField.value.traders.map(trader => trader.code);
        return this.traders.filter(trader => traderCodes.includes(trader.id));
      }
    }
    return this.traders
  }

  protected getTraderNameFromAccountTraders(formRecord: Order, accountDef: AccountDefinition) {
    let traderName = accountDef.traderName;
    if (!traderName) {
      const accountTrader = this.accountTraders.find(aTrader => aTrader.value.accountCode === accountDef.code
        && aTrader.value.owner === accountDef.owner
        && aTrader.value.customerName === accountDef.customerName
        && ((!accountDef.exchangeCode || ExchangeDetail.ALL_TEXT === accountDef.exchangeCode) ||
          (!aTrader.value.exchangeCode || ExchangeDetail.ALL_TEXT === aTrader.value.exchangeCode || aTrader.value.exchangeCode === accountDef.exchangeCode)));

      if (accountTrader) {
        let hasContract = true;
        if (accountTrader.value.contractListInclude) {
          if (!accountTrader.value.contractList.split(',').includes(formRecord.contractCode)) hasContract = false;
        }
        if (hasContract) {
          const trader = this.accountTraders.find(trader => trader.value.traderCode === accountTrader.value.traderCode)
          if (trader) {
            traderName = trader.text;
          }
        }
      }
    }
    return traderName;
  }

  public forceCustomerValues(record, customerName, customerId): void {
    if (customerId) {
      record.customerName = customerName;
      record.customerId = customerId;
    } else {
      record.customerName = undefined;
      record.customerId = undefined;
    }
    record.accountName = undefined;
    record.accountType = undefined;
    record.giveupAccountType = AccountType.GIVE_UP_CODE;
    record.executionFee = undefined;
    record.giveUpBrokerCode = undefined;
    record.giveUpCommission = undefined;
    record.giveUpMessage = undefined;
    record.giveUpMessage2 = undefined;
    record.giveUpMessage3 = undefined;
    record.broker = undefined;
    record.openClose = OpenClose.NO;
    record.reference1 = undefined;
    record.reference2 = undefined;
    record.reference3 = undefined;
    record.traderName = undefined;
    this.accounts.splice(0);
    this.forceAccountValues(record, '')
  }

  public forceAccountValues(record, accountCode): Customer {
    if (this.accounts.length == 0) {
      this.filterAccountFromCustomers(record);
    }
    let customer: Customer = undefined;
    const accountField = this.accounts.find(field => (!record.exchangeCode || record.exchangeCode === field.value.exchangeCode
        || (!field.value.exchangeCode && record.clearingHouse == field.value.clearingHouse))
      && field.text?.toLowerCase() === accountCode?.toLowerCase() /*|| field['select']*/);
    if (accountField) {
      const accountDef = {...accountField.value};
      record.accountName = accountDef.code;
      record.accountType = accountDef.accountTypeCode;
      record.giveupAccountType = accountDef.giveupAccountType;
      record.executionFee = accountDef.executionFee;
      record.giveUpBrokerCode = accountDef.giveUpBrokerCode;
      record.giveUpCommission = accountDef.giveUpCommission;
      record.giveUpMessage = accountDef.giveUpMessage ? accountDef.giveUpMessage.toUpperCase() : '';
      record.broker = accountDef.giveupMessage3;
      record.openClose = accountDef.openCloseForFutures;
      record.reference1 = accountDef.reference1 ? accountDef.reference1.toUpperCase() : '';
      record.reference2 = accountDef.reference2;
      record.reference3 = accountDef.reference3;

      const customerField = this.customers.find(customer => customer.id == '' + accountDef.customerId);
      if (customerField) {
        record.customerName = customerField.text;
        accountDef.customerName = customerField.text;
        record.customerId = customerField.id;
        customer = customerField.value;
      }
      record.traderName = this.getTraderNameFromAccountTraders(record, accountDef);
    } else if (!accountCode || accountCode === '') {
      record.accountName = undefined;
      record.accountType = AccountType.GIVE_UP_CODE;
      record.giveupAccountType = undefined;
      record.executionFee = undefined;
      record.giveUpBrokerCode = undefined;
      record.giveUpCommission = undefined;
      record.giveUpMessage = undefined;
      record.giveUpMessage2 = undefined;
      record.giveUpMessage3 = undefined;
      record.broker = undefined;
      record.openClose = undefined;
      record.reference1 = undefined;
      record.reference2 = undefined;
      record.reference3 = undefined;
      record.traderName = undefined;
    } else if (!accountField) {
      record.accountType = AccountType.GIVE_UP_CODE;
      record.giveupAccountType = undefined;
      record.executionFee = undefined;
      record.giveUpBrokerCode = undefined;
      record.giveUpCommission = undefined;
      record.giveUpMessage = undefined;
      record.giveUpMessage2 = undefined;
      record.giveUpMessage3 = undefined;
      record.broker = undefined;
      record.openClose = undefined;
      record.reference1 = undefined;
      record.reference2 = undefined;
      record.reference3 = undefined;
      record.traderName = undefined;
    }
    this.setBrokerageRate(record);
    this.setMoneyOwner(record);
    return customer;
  }

  public setBrokerageRate(record: any) {

    const execTraderField = this.execTraders.find(execTrader => execTrader.text == record.execTrader);
    const execTrader = execTraderField ? execTraderField.value : undefined;

    const customerField = this.customers.find(customer => customer.id == '' + record.customerId);
    const customer = customerField ? customerField.value : undefined;

    const accountField = this.accounts.find(field => (!record.exchangeCode || record.exchangeCode === field.value.exchangeCode
        || (!field.value.exchangeCode && record.clearingHouse == field.value.clearingHouse))
      && record.accountName && field.text.toLowerCase() === record.accountName.toLowerCase() /*|| field['select']*/);
    const account = accountField ? accountField.value : undefined;

    let brokerageTable = undefined;
    if (execTrader) {
      brokerageTable = this.brokerageTables
        .find(field => field.value.ownerCode === execTrader.owner
          && field.value.brokerageTableName === execTrader.brokerageTableName
          && (!field.value.exchangeCode || record.exchangeCode === field.value.exchangeCode)
          && (!field.value.clearingHouse || record.clearingHouse == field.value.clearingHouse)
          && ((record.strike == 0 && field.value.allFutures) || (record.strike != 0 && field.value.allOptions))
          && (!field.value.contractCode || field.value.contractCode.split(',').findIndex(value => value === record.contractCode) > -1));
    }
    if (account && !brokerageTable) {
      brokerageTable = this.brokerageTables
        .find(field => field.value.ownerCode === account.owner
          && field.value.brokerageTableName === account.agreementId
          && (!field.value.exchangeCode || record.exchangeCode === field.value.exchangeCode)
          && (!field.value.clearingHouse || record.clearingHouse == field.value.clearingHouse)
          && ((record.strike == 0 && field.value.allFutures) || (record.strike != 0 && field.value.allOptions))
          && (!field.value.contractCode || field.value.contractCode.split(',').findIndex(value => value === record.contractCode) > -1));
    }
    if (customer && !brokerageTable) {
      brokerageTable = this.brokerageTables
        .find(field => field.value.ownerCode === customer.owner
          && field.value.brokerageTableName === customer.brokerageTableName
          && (!field.value.exchangeCode || record.exchangeCode === field.value.exchangeCode)
          && (!field.value.clearingHouse || record.clearingHouse == field.value.clearingHouse)
          && ((record.strike == 0 && field.value.allFutures) || (record.strike != 0 && field.value.allOptions))
          && (!field.value.contractCode || field.value.contractCode.split(',').findIndex(value => value === record.contractCode) > -1));
    }

    if (brokerageTable) {
      record.rate = brokerageTable.value.amountPerLot;
      record.currency = brokerageTable.value.currency;
    } else {
      // record.rate = undefined;
      // record.currency = undefined;
    }
  }

  public setMoneyOwner(record: any) {

    const accountField = this.accounts.find(field => (!record.exchangeCode || record.exchangeCode === field.value.exchangeCode
        || (!field.value.exchangeCode && record.clearingHouse == field.value.clearingHouse))
      && record.accountName && field.text.toLowerCase() === record.accountName.toLowerCase() /*|| field['select']*/);
    const account = accountField ? accountField.value : undefined;

    let moneyOwner = undefined;
    if (account) {
      moneyOwner = this.moneyOwners
        .find(field => field.value.owner === account.owner
          && field.value.code === account.moneyOwner
        );
    }

    if (moneyOwner) {
      record.moneyOwner = moneyOwner.value.code;
    } else {
      // record.moneyOwner = undefined;
    }
  }

}
